import { boolean, number, string } from 'yup';

import { ManagedIntegrationListQueryResult } from '@frontend/api';

import {
  FeatureFlagData,
  FeatureFlagType,
} from 'modules/common/drawers/featureFlagDrawer/types';
import { FeatureFlagFormDataQueryResult } from 'modules/common/drawers/featureFlagDrawer/types';

export const numberValidation = number()
  .nullable()
  .typeError('Value must be a valid number')
  .integer('Value must be an integer')
  .min(0, 'Value must be greater than or equal to 0');

const requiredNumberValidation = numberValidation.required(
  'This field is required',
);

export const minRequiredNumberValidation = (value: number) =>
  requiredNumberValidation.min(
    value,
    `Value must be greater than or equal to ${value}`,
  );

export const getSchemaFromFeatureFlag = (
  flagData: FeatureFlagData,
  featureFlagsResponse: FeatureFlagFormDataQueryResult,
  managedIntegrations: ManagedIntegrationListQueryResult,
) => {
  if ('getSchema' in flagData && flagData.getSchema != undefined) {
    return flagData.getSchema(featureFlagsResponse, managedIntegrations);
  }

  const featureFlagType = flagData.type;

  switch (featureFlagType) {
    case FeatureFlagType.Number:
      return requiredNumberValidation;
    case FeatureFlagType.Boolean:
      return boolean();
    case FeatureFlagType.String:
      return string().oneOf(flagData.allowedValues, 'Invalid value');
    default: {
      const exhaustivenessCheck: never = featureFlagType;
      throw new Error(
        `Exhaustiveness check failed in getSchemaFromFeatureFlag: Unrecognized feature flag type: ${exhaustivenessCheck}`,
      );
    }
  }
};
